import React, { useEffect } from "react";
import yup from "yup";
import { useObserver } from "mobx-react";
import { FormStore } from "@modules/formx";
import { Grid, GridProps, GridSize } from "@material-ui/core";

export type FieldProps<FORM_DATA = any, STORE = any> = {
  order?: number;
  show?: (
    form: FormStore<FORM_DATA>,
    extra: { store: STORE; typeOptions: any; contractTypeToUpload: any }
  ) => boolean;
  isGroup?: boolean;
  schema?: yup.Schema<any> | {};
  gridProps?: GridProps;
  xs?: GridSize;
  md?: GridSize;
  name: string;
  render: (
    form: FormStore<FORM_DATA>,
    extra: { store: STORE; typeOptions: any; contractTypeToUpload: any }
  ) => React.ReactNode;
};

type Props = {
  fields: FieldProps[]; // if changed should be always new array. Avoid .push use [...fields, new field] instead to be sure validation effect would be fired
  form: any;
  gridContainerProps?: GridProps;
  extraProps?: any;
  skipChangeSchema?: boolean; // set this prop true if you have few DynamicFieldsGroup between 2 formtab
};

export function getSchema<
  T extends { schema?: yup.Schema<any> | {}; isGroup?: boolean; name: string }
>(fields: T[]) {
  // console.log(toJS(fields));
  let res = {};
  fields?.forEach((x) => {
    if (x.schema) {
      return x.isGroup ? (res = { ...res, ...x.schema }) : (res[x.name] = x.schema);
    }
  });
  return yup.object().shape(res);
}

// TODO move to common components
export function DynamicFieldsGroup({
  fields,
  form,
  gridContainerProps,
  extraProps,
  skipChangeSchema = false
}: Props) {
  useEffect(() => {
    if (!skipChangeSchema) {
      const schema = getSchema(fields);
      form.setSchema(schema);
    }
  }, [fields]);

  return useObserver(() => {
    return (
      <Grid container spacing={1} {...gridContainerProps}>
        {fields?.map(
          ({ xs = 4, order, show, render, md, gridProps }, i) =>
            show(form, extraProps) && (
              <Grid key={`${i}${order}`} item xs={xs} md={md} {...gridProps}>
                {render(form, extraProps)}
              </Grid>
            )
        )}
      </Grid>
    );
  });
}
